export const PATH = {
  home: "/",
  // menu
  mint: "/mint",
  gallery: "/gallery",
  howToConnect: "/how-to-connect",
  components: "/components",
  login: "/login",
  signUp: "/sign-up",
  inviteSentSignUp: "/invitation-create-password",
  forget: "/forget",
  reset: "/reset-password",
  resetSuccess: "/reset-success",
  emailVerification: "/verify",
  signingUpMessage: "/thanks-for-signing-up",
  confirmEmail: "/confirm-email",
  projects: "/projects",
  general: "/generals",
  changePhoneNumber: "/generals/change-phone-number",
  changeSecurityCode: "/generals/change-security-code",
  createProject: "/create-project",
  termsAndServices: "/terms-and-conditions",
  policies: "/privacy-policy",
  projectComponent: "/project-detail/:idProject",
  projectSensitiveData: "/project-sensitive",
  shareProjectBuild: "/project-build/:idBuild/share",
  draftBuild: "/draft-build/:idProject/:idProjectBuild",
  committedBuild: "/build-committed/:idProject/:idProjectBuild",
  buildDetail: "/build-detail/:idProjectComponent",
  buildHistory: "/build-history/:idProjectComponent",
  shareBuildDetail:
    "/build-detail/:idProjectComponent/:idProjectBuildComponent/share/histories",
  versionSpecification: "/version-specification/:idVersion",
  shareVersionSpecification: "/version-specification/:idVersion/share",
  shared: "/shared",
  projectComponentPCB:
    "/project/:titlePage/:idProjectComponent/PCB/:idProjectBuildComponent",
  projectComponentBOM:
    "/project/:titlePage/:idProjectComponent/BOM/:idProjectBuildComponent",
  projectComponentOther:
    "/project/:titlePage/:idProjectComponent/:type/:idProjectBuildComponent",
  projectComponentMech:
    "/project/:titlePage/:idProjectComponent/Mechanical/:idProjectBuildComponent",
  folder: "/project-detail/:idProject/folder/:idFolder",
  buildsOverview: "/builds",
  buildOverview: "/build/:status/:idProject/:idProjectBuild",
  defaultBuildOverview: "/build",
  conversations: "/conversations",
  settings: "/setting",
  workspaceSetting: "/workspace-setting",
  enableEncryption: "/enable-encryption",
  inviteesPCB:
    "/invitees/component/:idProjectComponent/PCB/:idProjectBuildComponent/:idProjectComponentHistory/:idConversation/:dbKeyOrganization",
  inviteesBOM:
    "/invitees/component/:idProjectComponent/BOM/:idProjectBuildComponent/:idProjectComponentHistory/:idConversation/:dbKeyOrganization",
  inviteesMechComponent:
    "/invitees/component/:idProjectComponent/Mechanical/:idProjectBuildComponent/:idProjectComponentHistory/:idConversation/:dbKeyOrganization",
  inviteesOther:
    "/invitees/component/:idProjectComponent/:type/:idProjectBuildComponent/:idProjectComponentHistory/:idConversation/:dbKeyOrganization",
  inviteesBuildPCB:
    "/invitees/component/:idProjectComponent/PCB/:idProjectBuildComponent/:idConversation/:dbKeyOrganization",
  inviteesBuildBOM:
    "/invitees/component/:idProjectComponent/BOM/:idProjectBuildComponent/:idConversation/:dbKeyOrganization",
  inviteesBuildMechComponent:
    "/invitees/component/:idProjectComponent/Mechanical/:idProjectBuildComponent/:idConversation/:dbKeyOrganization",
  inviteesBuildOther:
    "/invitees/component/:idProjectComponent/:type/:idProjectBuildComponent/:idConversation/:dbKeyOrganization",
  generalSearch: "/search",
  StorageUsage: "/storage-usage",
  secretChat: "/chat/:idConversation",
  notFound: "/404",
  addressBook: "/address-book",
  actionLog: "/action-logs",
  accessKey: "/access-keys",
  updatePhoneNumberAndSecurityCode: "/update-phone-number-and-security-code",
  syncCommitComponent: "/sync-history",
  organizationAdd: "/workspace/add",
  organizationEdit: "/workspace/edit",
  syncToOrganization: "/project-detail/:projectId/sync-to-workspace",
  shareKeyOrganization: "/share-key-workspace",
  groups: "/groups",
  userGroups: "/user-groups",
  groupDetail: "/groups/:id",
  assignToGroupPage: "/project-detail/:projectId/assign-groups-users",
  assignment: "/assign-to/:userId",
}
